import { Helpers } from '../../helpers';
import { IProductionGroup } from '../../interfaces/iproduction-group';
import { DrillGroup } from '../drill-group';
import { FracGroup } from '../frac-group';
import { ProductionGroupWell } from '../production-group-well';

export class ProductionGroupBase {
  ProductionGroupId: number;
  ScenarioId: number | null;
  Description: string | null;
  ProcessingOrder: number;
  Lag: number;
  BoundsOfWells_Computed: object | null;
  CenterOfWells_Computed: object | null;
  BoundsofWellsSetDate: Date | null;
  SourceFracGroupId: number | null;
  FirstWellStart: Date | null;
  LastWellEnd: Date | null;
  IsManuallyAdded: boolean;
  IsFromBaseScenario: boolean;
  SourceBaseScenarioProductionGroupId: number | null;
  SourceBaseScenarioDrillGroupId: number | null;
  CreationOrdinalNumber: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProductionGroupWells_ProductionGroup?: Array<ProductionGroupWell> | null;
  DrillGroup?: DrillGroup;
  FracGroup?: FracGroup;

  constructor(item?: IProductionGroup) {
    if (item) {

      this.ProductionGroupId = item.ProductionGroupId;
      this.ScenarioId = item.ScenarioId;
      this.Description = item.Description;
      this.ProcessingOrder = item.ProcessingOrder;
      this.Lag = item.Lag;
      this.BoundsOfWells_Computed = item.BoundsOfWells_Computed;
      this.CenterOfWells_Computed = item.CenterOfWells_Computed;
      this.BoundsofWellsSetDate = item.BoundsofWellsSetDate ? new Date(item.BoundsofWellsSetDate) : null;
      this.SourceFracGroupId = item.SourceFracGroupId;
      this.FirstWellStart = item.FirstWellStart ? new Date(item.FirstWellStart) : null;
      this.LastWellEnd = item.LastWellEnd ? new Date(item.LastWellEnd) : null;
      this.IsManuallyAdded = item.IsManuallyAdded;
      this.IsFromBaseScenario = item.IsFromBaseScenario;
      this.SourceBaseScenarioProductionGroupId = item.SourceBaseScenarioProductionGroupId;
      this.SourceBaseScenarioDrillGroupId = item.SourceBaseScenarioDrillGroupId;
      this.CreationOrdinalNumber = item.CreationOrdinalNumber;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProductionGroupWells_ProductionGroup = Helpers.createClassArray(ProductionGroupWell, item.ProductionGroupWells_ProductionGroup);
      this.DrillGroup = new DrillGroup(item.DrillGroup);
      this.FracGroup = new FracGroup(item.FracGroup);
    }
  }
}